import PlatformExpertsListContainer from './PlatformExpertsList.container'

export default PlatformExpertsListContainer